var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 0.666016C13.6 0.666016 17.3333 4.39935 17.3333 8.99935C17.3333 13.5993 13.6 17.3327 8.99996 17.3327C4.39996 17.3327 0.666626 13.5993 0.666626 8.99935C0.666626 4.39935 4.39996 0.666016 8.99996 0.666016ZM8.99996 15.666C12.6833 15.666 15.6666 12.6827 15.6666 8.99935C15.6666 5.31602 12.6833 2.33268 8.99996 2.33268C5.31663 2.33268 2.33329 5.31602 2.33329 8.99935C2.33329 12.6827 5.31663 15.666 8.99996 15.666ZM11.9466 4.87435L13.125 6.05268L8.99996 10.1777L7.82163 8.99935L11.9466 4.87435Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentSearch);
export default __webpack_public_path__ + "static/media/recent-search.65377dd520662005b59184be15bdc38e.svg";
export { ForwardRef as ReactComponent };